import { render, staticRenderFns } from "./DiagAuditTable.vue?vue&type=template&id=fdb5ea24&"
import script from "./DiagAuditTable.vue?vue&type=script&lang=js&"
export * from "./DiagAuditTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports